import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import {
  useCustomerManager,
  useSaleManager,
} from '../../../../../../ng-compat/hooks'
import {
  CurrentView,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'
import {
  isContactInfoUpdated,
  trimCustomerInfo,
} from '../LineItemFulfillmentUtils'
import { selectLineItem } from '../../../../../../state/slices/currentSale/currentSaleSlice'
import {
  markSaleCustomerContactInfoAsReviewed,
  selectOpenFulfilmentPopoverLineItemId,
} from '../../../../../../state/slices/uiStateSlice'
import { useAppDispatch, useAppSelector } from '../../../../../../state/hooks'
import { isDefinedFulfilmentType } from '../../../../../../models/fulfilment'

interface useLineItemFulfillmentReviewContactInfoFlowProps {
  onClose: () => void
}

export const useLineItemFulfillmentReviewContactInfoFlow = ({
  onClose,
}: useLineItemFulfillmentReviewContactInfoFlowProps) => {
  const {
    setCurrentView,
    currentCustomer,
    originalCustomer,
    setIsLoading,
  } = useLineItemFulfillmentContext()
  const t = useT()
  const saleManager = useSaleManager()
  const customerManager = useCustomerManager()
  const lineItemId = useAppSelector(selectOpenFulfilmentPopoverLineItemId)
  const lineItem = useAppSelector(selectLineItem(lineItemId))
  const dispatch = useAppDispatch()

  const handleContinueFromReviewContactInfoView = async () => {
    if (currentCustomer && originalCustomer) {
      const isUpdated = isContactInfoUpdated(currentCustomer, originalCustomer)
      if (isUpdated) {
        try {
          trimCustomerInfo(currentCustomer)
          setIsLoading(true)
          const savedCustomer = await customerManager.updateCustomer(
            currentCustomer
          )
          await saleManager.addCustomer(savedCustomer)
          goToNextView()
        } catch (_) {
          ToastNotifications.negative(
            t('Unable to update customer. Try again.')
          )
        } finally {
          setIsLoading(false)
        }
      } else {
        setIsLoading(true)
        await saleManager.addCustomer(currentCustomer)
        setIsLoading(false)
        goToNextView()
      }
    }
  }

  const goToNextView = () => {
    if (isDefinedFulfilmentType(lineItem?.fulfilmentType)) {
      onClose()
    } else {
      setCurrentView(CurrentView.FULFILMENT_METHOD)
    }

    dispatch(markSaleCustomerContactInfoAsReviewed())
  }

  return {
    handleContinueFromReviewContactInfoView,
  }
}
